import React from "react";

const Docs = () => {
    return (
        <div className="container mx-auto px-12 relative pt-162 min-h-calc-head py-8">
            <div className="wrapper mt-20">
                <h1 className="text-white text-5xl font-extralight mb-12">DOCS</h1>
            </div>
        </div>
    )
}

export default Docs;